import { Component, OnInit, Input, ViewChild, ElementRef, Inject, PLATFORM_ID, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { JssStylingService } from '../../JssStylingService';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';
import { isPlatformServer } from '@angular/common';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

@Component({
  selector: 'app-hero-slider',
  templateUrl: './hero-slider.component.html',
  styleUrls: ['./hero-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeroSliderComponent implements OnInit, AfterViewInit  {
  @Input() rendering: ComponentRendering;
  @ViewChild('HeroSlider', { static : false}) swiperSlider!: ElementRef;
  dynamicClass: string;
  jssStylingService: JssStylingService;
  devicedetectorService: CustomDeviceDetectorService;
  isMobile: boolean;
  swiper: Swiper;
  _isPlatformServer: boolean = false;

  constructor(jssStylingService: JssStylingService, devicedetectorService: CustomDeviceDetectorService,@Inject(PLATFORM_ID) public readonly platformId: string,) { 
    this.jssStylingService = jssStylingService;
    this.devicedetectorService = devicedetectorService;
    platformId 
  }

  ngOnInit() {
    // remove this after implementation is done
    console.log('heroSlider component initialized with component data', this.rendering);
    this._isPlatformServer = isPlatformServer(this.platformId);
    this.dynamicClass = this.jssStylingService.getComponentClass(this.rendering);
    this.isMobile = this.devicedetectorService.isMobile();
    if(!this._isPlatformServer){
      this.swiper = new Swiper(".eq-swiper-slider", {
        slidesPerView: "auto",
        autoplay: parseFloat((this.rendering.fields?.TimeRotation as any)?.value) && parseFloat((this.rendering.fields?.TimeRotation as any)?.value) > 0 ?
          {
            delay: parseFloat((this.rendering.fields?.TimeRotation as any)?.value)*1000,
          } : false ,
        speed:1200,
        freeMode: true,
        centeredSlides: false,
        spaceBetween: 32,
        grabCursor: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        modules:[Pagination , Autoplay]
      });
    }
  }

  ngAfterViewInit() {
    if(!this._isPlatformServer){
      //this.calculateMargin();
    }
  }
}
